// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","948":"2cca2479","976":"c16184b3"}[chunkId] || chunkId) + "-" + {"589":"fb6890905e30549e7fc3","678":"a5073d18d0e299a0ad8b","883":"2ecd90f0d44519985c8c","948":"a8c9384d216e6b6239c8","976":"b514c47f9918256f0f56"}[chunkId] + ".js";
};